import React from 'react'
import PropTypes from 'prop-types'
import NestedHoverMenuItem from './NestedHoverMenuItem'
import './NestedHoverMenu.scss'
class NestedHoverMenu extends React.Component {
  constructor (props) {
    super(props)

    this.nestedMenu = React.createRef()
    this.hoverMenuClashRight = this.hoverMenuClashRight.bind(this)
    this.animateIn = this.animateIn.bind(this)
    this.animateOut = this.animateOut.bind(this)

    this.state = {
      isActive: false
    }
  }

  componentDidMount () {
    if (this.hoverMenuClashRight()) {
      this.nestedMenu.current.parentElement.classList.add('menu-clash-right')
    }
  }

  animateIn () {
    this.setState({ isActive: true })
  }

  animateOut () {
    this.setState({ isActive: false })
  }

  hoverMenuClashRight () {
    const hoverMenuWidth = this.nestedMenu.current.clientWidth
    const hoverMenuRightOffset =
      window.innerWidth - this.nestedMenu.current.getBoundingClientRect().left
    return hoverMenuWidth > hoverMenuRightOffset
  }

  buildNestedMenu (options) {
    const menuOptions = options.map((option, idx) => {
      let itemSubMenu
      if (option.children && option.children.length > 0) {
        itemSubMenu = this.buildNestedMenu(option.children)
      }
      return (
        <NestedHoverMenuItem
          key={idx}
          label={option.text}
          marked={option.included}
          underlined={option.underlined}
          handleClick={option.handleClick}
          nonActive={option.nonActive}
          subMenu={itemSubMenu}
          processing={option.processing}
        />
      )
    })

    return (
      menuOptions
    )
  }

  render () {
    let menuClass = 'NestedHoverMenu__menu'
    if (this.state.isActive) {
      menuClass += ' NestedHoverMenu__menu--active'
    }

    return (
      <div className='NestedHoverMenu' onMouseLeave={this.animateOut}>
        <div className={menuClass}>
          <ul
            className='NestedOverMenu__content'
            ref={this.nestedMenu}
          >
            {this.buildNestedMenu(this.props.menuOptions)}
          </ul>
        </div>
        <div className='NestedHoverMenu__trigger'>
          {this.props.children({
            animateIn: this.animateIn,
            animateOut: this.animateOut
          })}
        </div>
      </div>
    )
  }
}

NestedHoverMenu.propTypes = {
  menuOptions: PropTypes.array
}

export default NestedHoverMenu
